import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const LOCAL_KEY = 'gearnode_cable_inventory_v1';
const cableRef = uid => doc(db, 'artifacts', 'gearnode-prod-v1', 'users', uid, 'settings', 'cables');

export const CABLE_TYPES = [
  { id: 'bnc', label: 'BNC / koncentryczny', endA: 'BNC', endB: 'BNC' },
  { id: 'hdmi', label: 'HDMI', endA: 'HDMI', endB: 'HDMI' },
  { id: 'xlr', label: 'XLR', endA: 'XLR F', endB: 'XLR M' },
  { id: 'jack', label: 'Jack 6.35 mm', endA: 'Jack 6.35 mm', endB: 'Jack 6.35 mm' },
  { id: 'ethernet', label: 'Ethernet / RJ45', endA: 'RJ45', endB: 'RJ45' },
  { id: 'usb-c', label: 'USB-C', endA: 'USB-C', endB: 'USB-C' },
  { id: 'usb', label: 'USB', endA: 'USB-A', endB: 'USB-B' },
  { id: 'mini-jack', label: 'Mini-jack', endA: 'Mini-jack 3.5 mm', endB: 'Mini-jack 3.5 mm' },
  { id: 'displayport', label: 'DisplayPort', endA: 'DisplayPort', endB: 'DisplayPort' },
  { id: 'iec-c13', label: 'IEC C13/C14', endA: 'Schuko', endB: 'IEC C13' },
  { id: 'iec-c19', label: 'IEC C19/C20', endA: 'Schuko', endB: 'IEC C19' },
  { id: 'powercon', label: 'PowerCON / TRUE1', endA: 'Schuko', endB: 'PowerCON/TRUE1' },
  { id: 'schuko', label: 'Schuko 230 V', endA: 'Schuko', endB: 'Schuko' },
  { id: 'dc', label: 'Zasilanie DC', endA: 'Zasilacz', endB: 'DC' },
];

export function createCable(typeId = 'bnc', sequence = 0) {
  const type = CABLE_TYPES.find(item => item.id === typeId) || CABLE_TYPES[0];
  const cableId = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `cable-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  return { cableId, typeId: type.id, label: `${type.label} #${sequence + 1}`, lengthM: '', endA: type.endA, endB: type.endB, status: 'available', notes: '' };
}

export function loadCableInventory() {
  try {
    const value = JSON.parse(localStorage.getItem(LOCAL_KEY));
    return Array.isArray(value) ? value : [];
  } catch { return []; }
}

export async function saveCableInventory(user, cables) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(cables));
  if (!user || user.isAnonymous) return;
  await setDoc(cableRef(user.uid), { items: cables, updatedAt: Date.now() }, { merge: true });
}

export function subscribeCableInventory(user, onData, onError) {
  if (!user || user.isAnonymous) return () => {};
  return onSnapshot(cableRef(user.uid), snapshot => {
    if (snapshot.exists()) onData(snapshot.data().items || []);
  }, onError);
}
